import { ExButton } from "../ExButton";
import { Download } from "lucide-react";
import domtoimage from 'dom-to-image-more';
import { useRef } from "react";
import { useThemeContext } from "../../theme";
import styled from "styled-components";
import LogoPequena from "../../images/logoPequena.png"
import LogoPequenaLigth from "../../images/logoPequenaLigth.png"
import moment from "moment";

const Logo = styled.img`
    width: 160px;
    padding: 32px;
`

export const DashboardPage = (props: { children: React.ReactNode, name: string }) => {
    const { themeMode } = useThemeContext();
    const ref = useRef<HTMLDivElement>(null);

    const downloadAsImage = () => {
        const node = ref.current

        const adjustClone = (node: any, clone: any, after: any) => {
            if (!after && clone.className === 'divexportmain')
                clone.style.transform = 'scale(0.9, 0.95)';

            if (!after && clone.className === 'divexportcontainer')
                clone.style.background = themeMode === 'dark' ? '#2B3035' : '#F8F9FA'

            return clone;
        };

        if (node)
            domtoimage.toBlob(node, { adjustClonedNode: adjustClone }).then(function (blob: any) {
                window.saveAs(blob, props.name + ' ' + moment(new Date()).format('DD-MM-YYYY') + '.png');
            })
    }

    return (
        <div style={{ paddingTop: '32px', paddingBottom: '32px' }}>
          
            <div style={{ position: "fixed", bottom: "90px", right: "32px", zIndex: 1000 }}>
                <ExButton iconcenter={<Download />} style={{ borderRadius: 50, minWidth: 50, minHeight: 50, alignItems: 'center', justifyContent: 'center', boxShadow: "0 2px 5px rgba(0,0,0,0.3)" }} onClick={() => downloadAsImage()} />
            </div>
            <div ref={ref} className="divexportcontainer" style={{}}>
                <div className="divexportmain">
                    {props.children}
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {themeMode === 'dark' ?
                            <Logo src={LogoPequena} /> :
                            <Logo src={LogoPequenaLigth} />}
                    </div>
                </div>
            </div>
        </div>
    )
}
